// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-page {
  padding: 24px;
}

.onboarding-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 24px;
  border-radius: 18px;
  background: radial-gradient(circle at top right, rgba(59, 130, 246, 0.2), transparent 34%), linear-gradient(135deg, #ffffff 0%, #eef4ff 100%);
  border: 1px solid #d8e6ff;
}

.onboarding-panel {
  border-radius: 18px;
  border: 1px solid #e8eef9;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
}

.onboarding-accent-panel {
  background: linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%);
}

.onboarding-welcome-panel {
  background: radial-gradient(circle at top left, rgba(16, 185, 129, 0.14), transparent 30%), linear-gradient(135deg, #fffdf6 0%, #f3fbf8 100%);
}

@media (max-width: 768px) {
  .onboarding-page {
    padding: 16px;
  }
  .onboarding-hero {
    flex-direction: column;
    padding: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/onboarding/Onboarding.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,6IACE;EAEF,yBAAA;AADF;;AAIA;EACE,mBAAA;EACA,yBAAA;EACA,8CAAA;AADF;;AAIA;EACE,6DAAA;AADF;;AAIA;EACE,6IACE;AAFJ;;AAMA;EACE;IACE,aAAA;EAHF;EAMA;IACE,sBAAA;IACA,aAAA;EAJF;AACF","sourcesContent":[".onboarding-page {\n  padding: 24px;\n}\n\n.onboarding-hero {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 24px;\n  border-radius: 18px;\n  background:\n    radial-gradient(circle at top right, rgba(59, 130, 246, 0.2), transparent 34%),\n    linear-gradient(135deg, #ffffff 0%, #eef4ff 100%);\n  border: 1px solid #d8e6ff;\n}\n\n.onboarding-panel {\n  border-radius: 18px;\n  border: 1px solid #e8eef9;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);\n}\n\n.onboarding-accent-panel {\n  background: linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%);\n}\n\n.onboarding-welcome-panel {\n  background:\n    radial-gradient(circle at top left, rgba(16, 185, 129, 0.14), transparent 30%),\n    linear-gradient(135deg, #fffdf6 0%, #f3fbf8 100%);\n}\n\n@media (max-width: 768px) {\n  .onboarding-page {\n    padding: 16px;\n  }\n\n  .onboarding-hero {\n    flex-direction: column;\n    padding: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
